import * as XLSX from 'xlsx';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim());
}

export function parseEmailsFromText(text: string): string[] {
  const parts = text.split(/[\n,;\t|]+/);
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of parts) {
    const email = part.trim().toLowerCase();
    if (email && isValidEmail(email) && !seen.has(email)) {
      seen.add(email);
      result.push(email);
    }
  }
  return result;
}

function extractEmailsFromRows(rows: unknown[][]): string[] {
  const emails: string[] = [];
  const seen = new Set<string>();
  for (const row of rows) {
    if (!Array.isArray(row)) continue;
    for (const cell of row) {
      const val = String(cell ?? '').trim().toLowerCase();
      if (val && isValidEmail(val) && !seen.has(val)) {
        seen.add(val);
        emails.push(val);
      }
    }
  }
  return emails;
}

export async function parseRecipientFile(file: File): Promise<string[]> {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';

  if (ext === 'csv' || ext === 'txt') {
    const text = await file.text();
    return parseEmailsFromText(text);
  }

  if (ext === 'xlsx' || ext === 'xls') {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: 'array' });
    const allEmails: string[] = [];
    const seen = new Set<string>();
    for (const sheetName of workbook.SheetNames) {
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, defval: '' });
      for (const email of extractEmailsFromRows(rows as unknown[][])) {
        if (!seen.has(email)) {
          seen.add(email);
          allEmails.push(email);
        }
      }
    }
    return allEmails;
  }

  throw new Error('Unsupported file type. Use .xlsx, .xls, .csv, or .txt');
}
